// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"4c15c7e5","704":"3cbd8f1b","741":"e1acd3c8"}[chunkId] + ".chunk.css";
};